export const SentaiLogoImage = "/Sentai_Logo_2020_RGB_white.svg";
export const PosterUrl = "/ScavHunt_Title_1000px.png";
export const HidiveLogoImage = "/HIDIVE_logo.svg";
export const EventDate = "October 26";
export const EventDetails = "Join us for an online event full of special guests, industry news, announcements, giveaways, and lots more!";

export const scavengerList = [
    { label: 'Vinland Saga Wallpaper'},
    { label: 'Getter Robo Arc Wallpaper' },
    { label: 'NANA Wallpaper' },
    { label: 'Princess Principal Crown Handler Wallpaper' },
    { label: 'Hero=Mask Wallpaper' },
    { label: 'Lone Wolf & Cub Wallpaper' },
    { label: 'Non Non Biyori Nonstop Wallpaper' },
    { label: 'MADE IN ABYSS: Dawn of the Deep Soul Wallpaper' },
]


// Prize 1 Vinland Saga Wallpaper
// Prize 2 Getter Robo Arc Wallpaper
// Prize 3 NANA Wallpaper
// Prize 4 Princess Principal Crown Handler Wallpaper
// Prize 5 Hero=Mask Wallpaper
// Prize 6 Lone Wolf & Cub Wallpaper
// Prize 7 Non Non Biyori Nonstop Wallpaper
// Prize 8 MADE IN ABYSS: Dawn of the Deep Soul Wallpaper